import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { appConfig } from '@/lib/app-config';
import App from './App';

if (appConfig.isEmployeeWeb) {
  document.documentElement.classList.add('theme-employee');
}
import { AuthProvider } from './store/auth';
import { BrandingProvider } from './store/branding';
import { PresenceProvider } from './store/presence';
import './index.css';

/**
 * Capture Chrome's install event before React mounts.
 *
 * Chrome can fire `beforeinstallprompt` during page load, which is earlier
 * than any component's first effect runs. The listener is added here, at module
 * scope, and stashes the event so InstallPrompt can still offer a real install
 * button instead of falling back to text instructions.
 */
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  (window as { __hrmaInstallPrompt?: Event }).__hrmaInstallPrompt = e;
});

const routerBasename =
  appConfig.basePath === '/' ? undefined : appConfig.basePath.replace(/\/$/, '');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <BrandingProvider>
        <AuthProvider>
          <PresenceProvider>
            <App />
          </PresenceProvider>
        </AuthProvider>
      </BrandingProvider>
    </BrowserRouter>
  </React.StrictMode>
);
